import axiosInstanceV2 from 'utils/InstanceAxios/InstanceAxiosV2';
import { Types } from '../reducers/systemRequests';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';
import errorMessages from 'utils/consts/errors';

//Synchronous

//Asynchronous
export const createSystemRequest = (systemData, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstanceV2.post(serverRoutes.SystemRequest.crud(), systemData)
        .then((response) => {
            dispatch({
                type: Types.CREATE_SYSTEM_REQUEST,
                payload: response.data
            });
            callback(true);
        })
        .catch((err) => {
            const message = (err.response?.data?.message || err.response?.data || err.request?.responseText) || err.message;
            const errorMessage = errorMessages[message] || message;
            toast.error(`Erro: ${errorMessage}`, { autoClose: 10000 });
            callback();
        })
    }
}

export const getSystemRequest = (id) => {
    return (dispatch) => {
        dispatch({
            type: Types.GET_SYSTEM_REQUEST,
            payload: null,
        });
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstanceV2.get(serverRoutes.SystemRequest.profile(`/${id}`))
        .then((response) => {
            dispatch({
                type: Types.GET_SYSTEM_REQUEST,
                payload: response.data
            })
        })
        .catch((err) => {
            console.log(err)
            const message = (err.response?.data?.message || err.response?.data || err.request?.responseText) || err.message;
            const errorMessage = errorMessages[message] || message;
            toast.error(`Erro ao buscar pelo pedido de sistema: ${errorMessage}`, { autoClose: 10000 });
            dispatch({
                type: Types.GET_SYSTEM_REQUEST,
                payload: null,
            });
        })
    }
}

export const getAllSystemRequests = (page, limit, query, sort="") => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
      axiosInstanceV2.get(serverRoutes.SystemRequest.crud(''), { params: { page, limit, query, sort } })
        .then((response) => {
            dispatch({
                type: Types.GET_SYSTEM_REQUESTS,
                payload: response.data
            });
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GET_SYSTEM_REQUESTS,
                payload: []
            });
        })
    }
}

export const getAllSystemRequestsFromUser = (username, page="", limit="", query="", sort="") => {
  if (!username) {
    return () => {}
  }
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
      axiosInstanceV2.get(serverRoutes.SystemRequest.crudUsername(`/${username}`), { params: { page, limit, query, sort } })
        .then((response) => {
            dispatch({
                type: Types.GET_SYSTEM_REQUESTS,
                payload: response.data
            });
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GET_SYSTEM_REQUESTS,
                payload: []
            });
        })
    }
}

export const giveSystemRequest = (systemRequestId, body ,query, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstanceV2.post(serverRoutes.SystemRequest.giveSystem(`/${systemRequestId}`), body, { params: query })
        .then((response) => {
            dispatch({
                type: Types.GIVE_SYSTEM_REQUEST,
                payload: response.data
            })
            toast.success('Sistema cadastrado com sucesso!', { autoClose: 10000 })
            callback();
        })
        .catch((err) => {
            const message = (err.response?.data?.message || err.response?.data || err.request?.responseText) || err.message;
            const errorMessage = errorMessages[message] || message;
            toast.error(`Erro durante o cadastro do sistema: ${errorMessage}`, { autoClose: 10000 })
            dispatch({
                type: Types.GIVE_SYSTEM_REQUEST,
            })
        })
    }
}

export const denySystemRequest = (systemRequestId, body ,query, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
      axiosInstanceV2.post(serverRoutes.SystemRequest.denySystem(`/${systemRequestId}`), body, { params: query })
        .then((response) => {
            dispatch({
                type: Types.DENY_SYSTEM_REQUEST,
                payload: response.data
            })
            toast.success('Pedido negado com sucesso!', { autoClose: 10000 });
            callback();
        })
        .catch((err) => {
            console.log(err)
            const message = (err.response?.data?.message || err.response?.data || err.request?.responseText) || err.message;
            const errorMessage = errorMessages[message] || message;
            toast.error(`Erro durante negação do pedido: ${errorMessage}`, { autoClose: 10000 });
            dispatch({
                type: Types.DENY_SYSTEM_REQUEST,
                payload: []
            })
        })
    }
}

export const removeSystemRequest = (systemRequestId, query, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstanceV2.delete(serverRoutes.SystemRequest.crud(`/${systemRequestId}`), { params: query })
        .then((response) => {
            dispatch({
                type: Types.REMOVE_SYSTEM_REQUEST,
                payload: response.data
            });
            toast.success('Pedido removido com sucesso!', { autoClose: 10000 });
            callback();
        })
        .catch((err) => {
            console.log(err)
            const message = (err.response?.data?.message || err.response?.data || err.request?.responseText) || err.message;
            const errorMessage = errorMessages[message] || message;
            toast.error(`Erro durante remoção do pedido: ${errorMessage }`, { autoClose: 10000 })
            dispatch({
                type: Types.REMOVE_SYSTEM_REQUEST,
                payload: [],
            })
        })
    }
}
